import type { CreateTrailerInput } from '@chukua/common';
import { useState } from 'react';
import { ApiError } from '../../../../../shared/shared.api';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { createTrailer } from '../trailers.api';

/** Creating a trailer from the Units list; a form failure stays inline (CLAUDE.md → Web conventions). */
export function useCreateTrailer(onCreated: () => void) {
  const [createError, setCreateError] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);
  const toast = useToast();

  /** Returns whether it succeeded, so the drawer knows to close itself. */
  async function create(input: CreateTrailerInput): Promise<boolean> {
    setCreateError(null);
    setCreating(true);
    try {
      await createTrailer(input);
      onCreated();
      toast.success(`${input.registration} created`);
      return true;
    } catch (err) {
      setCreateError(
        err instanceof ApiError && err.status === 409
          ? 'A trailer with this registration already exists.'
          : 'Could not create the trailer — check the fields and try again.',
      );
      return false;
    } finally {
      setCreating(false);
    }
  }

  return { createError, creating, create, resetCreateError: () => setCreateError(null) };
}
